var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIDatePicker',{attrs:{"error":_vm.errors.endPeriod,"placeholder":_vm.$t('bi.field.placeholder.choose-period'),"disabled-date":_vm.disabledDate,"only-month":""},on:{"change":_vm.handleChange},model:{value:(_vm.formValues.endPeriod),callback:function ($$v) {_vm.$set(_vm.formValues, "endPeriod", $$v)},expression:"formValues.endPeriod"}})
}
var staticRenderFns = []

export { render, staticRenderFns }